import styled from 'styled-components';

export const Container = styled.div`
  div.content_wrapper {
    width: 85vw;
    margin: 0 7.5vw;

    h1 {
      margin: 15px 0;
    }
  }
`;

export const FormWrapper = styled.form`
  background-color: #f9f9f9;
  padding: 2rem;
  margin-bottom: 2rem;
  border-radius: 10px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
`;


export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;

    ${FormGroup} {
      margin-right: 0 !important;
      margin-bottom: 1rem;
    }
  }
`;

export const Label = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 2px solid #ccc;
  border-radius: 8px;
  outline: none;

  &:focus {
    border-color: #0e2244;
    box-shadow: 0 0 0 2px rgba(14, 34, 68, 0.2);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 2px solid #ccc;
  border-radius: 8px;
  background-color: white;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 0.75rem;
  font-size: 1rem;
  border: 2px solid #ccc;
  border-radius: 8px;
  resize: vertical;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  input {
    accent-color: #0e2244;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;


export const SubmitButton = styled.button`
  width: 30%;
  padding: 0.75rem 2rem;
  background-color: #0e2244;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #13396f;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: transparent;
  border: none;
  color: #0e2244;
  padding: 0.5rem 0rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;

  .icon {
    font-size: 1.2rem;
  }

  &:hover {
    text-decoration: underline;

  }
`;

